import './Copyright.css';

const Copyright =()=>{
    return(<div className="container-fluid copyright">
    <p>© 2019 POLO - Responsive Multi-Purpose HTML5 Template. All Rights Reserved. INSPIRO</p>
    </div>)

}

export default Copyright;